import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing.km8};
  `}
`;

export const Header = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing.km2};
  `}
`;

export const PartnersContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    gap: ${spacing.km6};
  `}
`;

export const HeaderContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    align-items: center;
    gap: ${spacing.km4};
  `}
`;

export const FreeTagContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    align-items: center;
    gap: ${spacing.km2};
  `}
`;

export const ValueFee = styled.span`
  ${({ theme: { color, font } }) => css`
    color: ${color.text.neutral.weak};
    font-weight: ${font.weight.medium};
    font-size: ${font.size.m4};
    text-decoration: line-through;
  `}
`;
